module.exports = "<div class=\"<%= term %>\">{{ $ctrl.term }}</div>\n<div class=\"definition\" ng-transclude></div>"